import { ForgotpasswordForm } from 'features/auth/components/forgot-password';
import logo from 'assets/images/bebrave.png';
import { useTranslation } from 'react-i18next';

export function ForgotPasswordPage() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-6">
      <div className="w-16 h-16 mb-2">
        <img src={logo} alt="logo" className="w-full h-full object-contain" />
      </div>
      <div>
        <div className="text-2xl font-bold text-high-emphasis">{t('FORGOT_PASSWORD')}</div>
        <div className="flex gap-1 mt-1">
          <div className="text-sm font-normal text-medium-emphasis">
            {t('FORGOT_PASSWORD_DESCRIPTION')}
          </div>
        </div>
      </div>
      <ForgotpasswordForm />
    </div>
  );
}
